export default __webpack_public_path__ + "static/media/37.5bb771c6.png";